import styled from 'styled-components';
import Container from 'components/Container';
import { H1 } from 'components/Typography';
import { th } from 'style/theme';

export const NPSContainer = styled(Container)`
  color: ${th('colors.white')};
`;

export const Heading = styled(H1)`
  margin-bottom: 40px;
`;
